import React, { Component } from 'react';
import { Jumbotron } from 'react-bootstrap';

class Jumbo extends Component {

  render(){
    return(
      <Jumbotron>
        <h1>Find din næste bolig allerede nu!</h1>
        <p>Vælg by nedenfor</p>
      </Jumbotron>
    )
  }
}

export default Jumbo
